export default __webpack_public_path__ + "static/media/landing_animado.c72830a7.gif";